import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="checkbox-dropdown"

// Used in: filter form partials enum and assoc
// Purpose: Creates a flowbite dropdown that works together with select 3 to produce a dropdown of available options and display no. of selected options.
// Refactor: could be added to select 3 controller

export default class extends Controller {
  static targets = ['info', 'count', 'total', 'inputs', 'button', 'dropdown'];
  connect() {
    console.log('checkbox-dropdown controller connected');
    this.totalTarget.innerText = this.inputsTargets.length;
    this.update();
    const context = this;
    // Set the element that trigger the dropdown menu on click
    const triggerEl = this.buttonTarget;
    // Set the dropdown menu element
    const targetEl = this.dropdownTarget;
    // Options with default values, update the displayed options count on hide of the dropdown
    const options = {
      placement: 'bottom',
      onHide: () => {
        context.update();
      },
      onShow: () => {
        // console.log('dropdown has been shown');
      },
    };
    const dropdown = new Dropdown(targetEl, triggerEl, options);
  }

  update() {
    this.countTarget.innerText = this.inputsTargets.filter(
      (x) => x.checked
    ).length;
  }
}
